
const taskSquareRoute = {
  path: '/',
  name: '首页',
  component: () => import('@/views/task/task-square'),
  meta: {hidden: true}
}
export default taskSquareRoute



// WEBPACK FOOTER //
// ./src/router/modules/taskSquare.js